import React, { ReactNode } from 'react';
import { FC, PropsWithChildren } from 'react';
import Typography from '@mui/material/Typography';
import styles from './settingsFormLayout.module.scss';

type Props = {
  label: string;
  description?: string | ReactNode;
};

const SettingsBlock: FC<PropsWithChildren<Props>> = ({ label, description, children }) => {
  return (
    <div className={styles.block}>
      <div className={styles.info}>
        <Typography variant="button2">{label}</Typography>
        <Typography variant="body2">{description}</Typography>
      </div>
      <div className={styles.input}>{children}</div>
    </div>
  );
};

export default SettingsBlock;
